// short hand for addEventListener
export const renderCloseIcon = (button: HTMLButtonElement) => {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");

  svg.setAttribute("fill", "none");
  svg.setAttribute("width", "8");
  svg.setAttribute("height", "9");
  svg.setAttribute("viewBox", "0 0 8 9");

  path.setAttribute(
    "d",
    "M8 1.2L7.3 0.5L4 3.8L0.7 0.5L0 1.2L3.3 4.5L0 7.8L0.7 8.5L4 5.2L7.3 8.5L8 7.8L4.7 4.5L8 1.2Z"
  );
  path.setAttribute("fill", "white");

  svg.appendChild(path);

  return button.appendChild(svg);
};
